import noticeError from "./notice-error";
import { requestHelper } from "./request-helper";

export async function fetchSchoolList(orgSearchUrl, country, name) {
  try {
    const url = new URL(decodeURIComponent(orgSearchUrl));
    url.searchParams.set("country", country);
    url.searchParams.set("name", name);
    const response = await requestHelper.get({
      url: url.href,
      isThirdParty: true,
    });

    if (response.status !== 200) {
      throw new Error("SheerId failed to fetch organisations");
    }

    return await response.data;
  } catch (error) {
    if (error?.message === "Network Error") {
      return {
        networkError: true,
      };
    }
    noticeError(error);
  }
}
